import { User } from "@/v2/types";

function hasAnyPermission(
    user: User | null,
    requestedPermission: {
        module: string;
        scope: string[];
    },
) {
    if (!user) {
        return false;
    }

    if (user.is_super_admin) {
        return true;
    }

    if (user.is_admin || user?.roles?.some((role: any) => role.is_admin)) {
        return true;
    }

    if (user?.direct_permissions) {
        for (const permission of user.direct_permissions) {
            if (
                requestedPermission.scope.some(
                    (reqPer: string) => reqPer == permission.handle,
                )
            ) {
                return true;
            }
        }
    }

    if (user?.roles) {
        for (const role of user.roles) {
            if (role?.module_permissions) {
                for (const permission of role.module_permissions) {
                    if (requestedPermission.module !== permission.module.handle)
                        continue;

                    if (permission.full_access_to_module) return true;
                    if (
                        requestedPermission.scope.some((reqPermission) =>
                            permission?.method?.some(
                                (methodPer: string) =>
                                    reqPermission === methodPer,
                            ),
                        )
                    ) {
                        return true;
                    }
                }
            }
        }
    }

    return false;
}

export default hasAnyPermission;
